// Profile.js
import React, { useState } from 'react';
import './Pages/PagesCss/Profile.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ic = {
  Overview:     (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/><rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8"/></svg>,
  Profile:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8"/><path d="M4 20C4 17.2386 7.58172 15 12 15C16.4183 15 20 17.2386 20 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Security:     (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Billing:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 10H22" stroke="currentColor" strokeWidth="1.8"/><path d="M6 15H10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  History:      (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Usage:        (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 20V14M8 20V10M12 20V4M16 20V10M20 20V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Edit:         (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M17 3L21 7L7 21H3V17L17 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
  Eye:          (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><ellipse cx="12" cy="12" rx="9" ry="5" stroke="currentColor" strokeWidth="1.8"/><circle cx="12" cy="12" r="2.5" stroke="currentColor" strokeWidth="1.8"/></svg>,
  EyeOff:       (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M3 3L21 21M10.5 10.6C10.19 10.9 10 11.33 10 11.82C10 13.01 11.12 13.98 12.5 13.98C13.09 13.98 13.63 13.81 14.05 13.5M6.5 6.6C4.5 7.8 3 9.7 3 12C3 14.5 5 17.5 12 17.5C13.6 17.5 15 17.2 16.2 16.7M9 4.6C9.9 4.2 10.9 4 12 4C19 4 21 7 21 12C21 13.1 20.7 14.2 20.1 15.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Trash:        (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M3 6H21M8 6V4H16V6M19 6L18 20H6L5 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Download:     (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 4V16M12 16L8 12M12 16L16 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M4 20H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Check:        (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Alert:        (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 9V13M12 17H12.01M10.3 3.5L2.5 17C1.8 18.2 2.7 19.7 4.2 19.7H19.8C21.3 19.7 22.2 18.2 21.5 17L13.7 3.5C13 2.3 11 2.3 10.3 3.5Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Pause:        (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor"/><rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor"/></svg>,
  Zap:          (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...p}><path d="M13 2L4.5 13.5H12L11 22L19.5 10.5H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>,
  Merge:        (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 6H20M4 12H20M4 18H14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M17 15L20 18L17 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Compress:     (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 8L12 3L20 8V16L12 21L4 16V8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
  Convert:      (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 7H13M13 7L10 4M13 7L10 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M20 17H11M11 17L14 14M11 17L14 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Sign:         (p) => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 20H20M6 16L14 8L16 10L8 18H6V16Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/></svg>,
  Logout:       (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M16 17L21 12L16 7M21 12H9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Menu: (p) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" strokeWidth="1.8"/></svg>,
  X:            (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
};

// ─── Mock data ────────────────────────────────────────────────────────────────
const USER = {
  name: 'Alex Johnson',
  email: 'alex.johnson@email.com',
  avatar: 'AJ',
  plan: 'Pro',
  memberSince: 'March 2024',
  nextBilling: 'Apr 18, 2026',
};

const STATS = [
  { label: 'Files Processed', value: '284',  sub: 'this month',  color: '#3B82F6', icon: Ic.Zap },
  { label: 'Data Processed',  value: '1.2GB',sub: 'this month',  color: '#10B981', icon: Ic.Usage },
  { label: 'Tools Used',      value: '11',   sub: 'of 22 tools', color: '#8B5CF6', icon: Ic.Overview },
  { label: 'Days Active',     value: '23',   sub: 'this month',  color: '#F59E0B', icon: Ic.History },
];

const TOOL_USAGE = [
  { name: 'Merge PDF',    icon: Ic.Merge,    count: 84, pct: 84 },
  { name: 'Compress PDF', icon: Ic.Compress, count: 62, pct: 62 },
  { name: 'PDF to Word',  icon: Ic.Convert,  count: 51, pct: 51 },
  { name: 'Sign PDF',     icon: Ic.Sign,     count: 38, pct: 38 },
  { name: 'Split PDF',    icon: Ic.Merge,    count: 29, pct: 29 },
  { name: 'OCR PDF',      icon: Ic.Compress, count: 20, pct: 20 },
];

const WEEK_DATA = [40, 75, 55, 90, 62, 110, 84];
const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const HISTORY = [
  { id: 1, tool: 'Merge PDF',    file: 'quarterly_report_final.pdf',  size: '2.4 MB',  date: 'Today, 2:14 PM' },
  { id: 2, tool: 'Compress PDF', file: 'presentation_v3.pdf',         size: '8.1 MB',  date: 'Today, 10:05 AM' },
  { id: 3, tool: 'PDF to Word',  file: 'contract_template.pdf',       size: '1.2 MB',  date: 'Yesterday, 4:30 PM' },
  { id: 4, tool: 'Sign PDF',     file: 'nda_client_signed.pdf',       size: '0.8 MB',  date: 'Yesterday, 11:15 AM' },
  { id: 5, tool: 'Split PDF',    file: 'annual_report_2024.pdf',      size: '14.2 MB', date: 'Mar 16, 9:00 AM' },
  { id: 6, tool: 'OCR PDF',      file: 'scanned_invoice_march.pdf',   size: '3.6 MB',  date: 'Mar 15, 3:45 PM' },
  { id: 7, tool: 'Watermark',    file: 'proposal_draft.pdf',          size: '1.9 MB',  date: 'Mar 14, 1:20 PM' },
  { id: 8, tool: 'Compress PDF', file: 'photoshoot_catalog.pdf',      size: '22.4 MB', date: 'Mar 13, 8:55 AM' },
];

// ─── Bar chart ────────────────────────────────────────────────────────────────
const BarChart = () => {
  const max = Math.max(...WEEK_DATA);
  return (
    <div className="pf-chart">
      {WEEK_DATA.map((v, i) => (
        <div key={i} className="pf-chart-col">
          <div className="pf-bar-wrap">
            <div className="pf-bar" style={{ height: `${(v / max) * 100}%` }} title={`${v} files`} />
          </div>
          <span className="pf-chart-day">{WEEK_DAYS[i]}</span>
        </div>
      ))}
    </div>
  );
};

// ─── Sections ─────────────────────────────────────────────────────────────────
const SectionOverview = () => (
  <div className="pf-section">
    <div className="pf-section-head">
      <h2 className="pf-section-title">Overview</h2>
      <p className="pf-section-sub">Your activity summary for this month</p>
    </div>
    <div className="pf-stats-grid">
      {STATS.map((s, i) => (
        <div className="pf-stat-card" key={i} style={{ '--sc': s.color }}>
          <div className="pf-stat-icon" style={{ background: `${s.color}14`, color: s.color }}>
            <s.icon />
          </div>
          <div>
            <div className="pf-stat-val">{s.value}</div>
            <div className="pf-stat-lbl">{s.label}</div>
            <div className="pf-stat-sub">{s.sub}</div>
          </div>
        </div>
      ))}
    </div>
    <div className="pf-row-2">
      <div className="pf-card pf-card--chart">
        <div className="pf-card-head">
          <span className="pf-card-title">Files this week</span>
          <span className="pf-card-total">516 total</span>
        </div>
        <BarChart />
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Top tools used</span></div>
        <div className="pf-tool-list">
          {TOOL_USAGE.map((t, i) => (
            <div className="pf-tool-row" key={i}>
              <span className="pf-tool-name"><span className="pf-tool-ico"><t.icon /></span>{t.name}</span>
              <div className="pf-tool-bar-wrap"><div className="pf-tool-bar" style={{ width: `${t.pct}%` }} /></div>
              <span className="pf-tool-count">{t.count}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="pf-card pf-plan-usage-card">
      <div className="pf-card-head">
        <span className="pf-card-title">Plan usage</span>
        <span className="pf-plan-badge" style={{ background: '#EFF6FF', color: '#3B82F6' }}>Pro</span>
      </div>
      <div className="pf-usage-rows">
        {[
          { label: 'Files today', used: 0,   unit: null },
          { label: 'Storage',     used: 1.2, unit: 'GB', limitLabel: '100 GB', pct: 1.2 },
        ].map((r, i) => (
          <div key={i} className="pf-usage-row">
            <div className="pf-usage-meta">
              <span className="pf-usage-label">{r.label}</span>
              <span className="pf-usage-value">{r.unit ? `${r.used} ${r.unit} of ${r.limitLabel}` : 'Unlimited'}</span>
            </div>
            {r.unit && <div className="pf-usage-track"><div className="pf-usage-fill" style={{ width: `${r.pct}%` }} /></div>}
          </div>
        ))}
      </div>
    </div>
  </div>
);

const SectionProfile = () => {
  const [form, setForm] = useState({ name: USER.name, email: USER.email });
  const [saved, setSaved] = useState(false);
  const save = () => { setSaved(true); setTimeout(() => setSaved(false), 2500); };
  return (
    <div className="pf-section">
      <div className="pf-section-head">
        <h2 className="pf-section-title">Profile</h2>
        <p className="pf-section-sub">Manage your personal details</p>
      </div>
      <div className="pf-card pf-avatar-card">
        <div className="pf-avatar-wrap">
          <div className="pf-avatar-lg">{USER.avatar}</div>
          <div>
            <p className="pf-avatar-name">{form.name}</p>
            <p className="pf-avatar-email">{form.email}</p>
            <p className="pf-avatar-since">Member since {USER.memberSince}</p>
          </div>
        </div>
        <button className="pf-btn pf-btn--ghost pf-btn--sm"><Ic.Edit /> Change photo</button>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Personal information</span></div>
        <div className="pf-form">
          <div className="pf-field-row">
            <div className="pf-field">
              <label className="pf-label">Full name</label>
              <input className="pf-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
            </div>
            <div className="pf-field">
              <label className="pf-label">Email address</label>
              <input className="pf-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
            </div>
          </div>
          <div className="pf-form-footer">
            {saved && <span className="pf-saved-msg"><Ic.Check /> Changes saved</span>}
            <button className="pf-btn pf-btn--primary" onClick={save}>Save changes</button>
          </div>
        </div>
      </div>
      <div className="pf-card pf-card--danger">
        <div className="pf-card-head"><span className="pf-card-title pf-danger-title"><Ic.Alert /> Danger zone</span></div>
        <div className="pf-danger-row">
          <div>
            <p className="pf-danger-label">Delete account</p>
            <p className="pf-danger-desc">Permanently delete your account and all associated data. This cannot be undone.</p>
          </div>
          <button className="pf-btn pf-btn--danger">Delete account</button>
        </div>
      </div>
    </div>
  );
};

const SectionSecurity = () => {
  const [show, setShow] = useState({ curr: false, new: false, confirm: false });
  const [pwForm, setPwForm] = useState({ curr: '', new: '', confirm: '' });
  const [saved, setSaved] = useState(false);
  const save = () => { setSaved(true); setTimeout(() => setSaved(false), 2500); };
  return (
    <div className="pf-section">
      <div className="pf-section-head">
        <h2 className="pf-section-title">Security</h2>
        <p className="pf-section-sub">Manage your password and account security</p>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Change password</span></div>
        <div className="pf-form">
          {[{ key: 'curr', label: 'Current password' }, { key: 'new', label: 'New password' }, { key: 'confirm', label: 'Confirm new password' }].map(({ key, label }) => (
            <div className="pf-field" key={key}>
              <label className="pf-label">{label}</label>
              <div className="pf-input-wrap">
                <input className="pf-input" type={show[key] ? 'text' : 'password'} placeholder="••••••••" value={pwForm[key]} onChange={e => setPwForm(f => ({ ...f, [key]: e.target.value }))} />
                <button className="pf-input-eye" onClick={() => setShow(s => ({ ...s, [key]: !s[key] }))} type="button">
                  {show[key] ? <Ic.EyeOff /> : <Ic.Eye />}
                </button>
              </div>
            </div>
          ))}
          {pwForm.new.length > 0 && (
            <div className="pf-pw-strength">
              <div className="pf-pw-bars">
                {[1,2,3,4].map(i => (
                  <div key={i} className="pf-pw-bar" style={{ background: pwForm.new.length >= i * 3 ? (pwForm.new.length < 6 ? '#EF4444' : pwForm.new.length < 9 ? '#F59E0B' : '#10B981') : undefined }} />
                ))}
              </div>
              <span className="pf-pw-label">{pwForm.new.length < 6 ? 'Weak' : pwForm.new.length < 9 ? 'Fair' : 'Strong'}</span>
            </div>
          )}
          <div className="pf-form-footer">
            {saved && <span className="pf-saved-msg"><Ic.Check /> Password updated</span>}
            <button className="pf-btn pf-btn--primary" onClick={save}>Update password</button>
          </div>
        </div>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Two-factor authentication</span></div>
        <div className="pf-2fa-row">
          <div>
            <p className="pf-2fa-label">Authenticator app</p>
            <p className="pf-2fa-desc">Use an authenticator app like Google Authenticator for an extra layer of security.</p>
          </div>
          <div className="pf-2fa-status">
            <span className="pf-status-dot pf-status-dot--off" />
            <span className="pf-status-text">Not enabled</span>
            <button className="pf-btn pf-btn--outline pf-btn--sm">Enable</button>
          </div>
        </div>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Active sessions</span></div>
        {[
          { device: 'Chrome on macOS',    location: 'Houston, TX', time: 'Now current session', current: true },
          { device: 'Safari on iPhone',   location: 'Houston, TX', time: '2 hours ago',            current: false },
          { device: 'Firefox on Windows', location: 'Austin, TX',  time: 'Yesterday, 6:30 PM',     current: false },
        ].map((s, i) => (
          <div key={i} className="pf-session-row">
            <div className="pf-session-info">
              <p className="pf-session-device">{s.device}{s.current && <span className="pf-current-tag">Current</span>}</p>
              <p className="pf-session-meta">{s.location} · {s.time}</p>
            </div>
            {!s.current && <button className="pf-btn pf-btn--ghost pf-btn--sm pf-btn--red">Revoke</button>}
          </div>
        ))}
      </div>
    </div>
  );
};

const SectionBilling = () => {
  const [showCancel, setShowCancel] = useState(false);
  return (
    <div className="pf-section">
      <div className="pf-section-head">
        <h2 className="pf-section-title">Billing & Subscription</h2>
        <p className="pf-section-sub">Manage your plan, payment and invoices</p>
      </div>
      <div className="pf-card pf-plan-card">
        <div className="pf-plan-left">
          <div>
            <div className="pf-plan-name-row">
              <span className="pf-plan-name">Pro Plan</span>
              <span className="pf-plan-badge-blue">Active</span>
            </div>
            <p className="pf-plan-price-line">$7.99 <span>/ month</span></p>
            <p className="pf-plan-renew">Next billing on {USER.nextBilling}</p>
          </div>
          
        </div>
        <div className="pf-plan-actions">
          <button className="pf-btn pf-btn--primary pf-btn--sm">Upgrade to Business</button>
          <button className="pf-btn pf-btn--outline pf-btn--sm" onClick={() => setShowCancel(true)}><Ic.Pause /> Pause subscription</button>
          <button className="pf-btn pf-btn--ghost pf-btn--sm pf-btn--red" onClick={() => setShowCancel(true)}>Cancel plan</button>
        </div>
      </div>
      {showCancel && (
        <div className="pf-modal-overlay" onClick={() => setShowCancel(false)}>
          <div className="pf-modal" onClick={e => e.stopPropagation()}>
            <div className="pf-modal-icon pf-modal-icon--warn"><Ic.Alert /></div>
            <h3 className="pf-modal-title">Cancel subscription?</h3>
            <p className="pf-modal-body">You'll keep Pro access until <strong>Apr 18, 2026</strong>. After that you'll revert to the Free plan 2 files/day, 10 MB limit.</p>
            <div className="pf-modal-btns">
              <button className="pf-btn pf-btn--ghost" onClick={() => setShowCancel(false)}>Keep Pro</button>
              <button className="pf-btn pf-btn--danger" onClick={() => setShowCancel(false)}>Yes, cancel</button>
            </div>
          </div>
        </div>
      )}
      <div className="pf-card">
        <div className="pf-card-head">
          <span className="pf-card-title">Payment method</span>
          <button className="pf-btn pf-btn--ghost pf-btn--sm"><Ic.Edit /> Change card</button>
        </div>
        <div className="pf-card-row">
          <div className="pf-credit-card">
            <div className="pf-cc-chip" />
            <div className="pf-cc-number">•••• •••• •••• 4242</div>
            <div className="pf-cc-meta"><span>VISA</span><span>Expires 09/27</span></div>
          </div>
          <div className="pf-card-info">
            <p className="pf-card-info-label">Visa ending in 4242</p>
            <p className="pf-card-info-sub">Expires September 2027</p>
            <button className="pf-btn pf-btn--ghost pf-btn--sm pf-btn--red" style={{ marginTop: '0.5rem' }}><Ic.Trash /> Remove card</button>
          </div>
        </div>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">Invoice history</span></div>
        <table className="pf-invoice-table">
          <thead><tr><th>Date</th><th>Description</th><th>Amount</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {[
              { date: 'Mar 18, 2026', desc: 'Pro Plan Monthly', amount: '$7.99' },
              { date: 'Feb 18, 2026', desc: 'Pro Plan Monthly', amount: '$7.99' },
              { date: 'Jan 18, 2026', desc: 'Pro Plan Monthly', amount: '$7.99' },
              { date: 'Dec 18, 2025', desc: 'Pro Plan Monthly', amount: '$7.99' },
            ].map((inv, i) => (
              <tr key={i}>
                <td>{inv.date}</td><td>{inv.desc}</td>
                <td className="pf-inv-amount">{inv.amount}</td>
                <td><span className="pf-inv-paid">✓ Paid</span></td>
                <td><button className="pf-inv-dl"><Ic.Download /> PDF</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SectionHistory = () => {
  const [filter, setFilter] = useState('all');
  const tools = [...new Set(HISTORY.map(h => h.tool))];
  const filtered = filter === 'all' ? HISTORY : HISTORY.filter(h => h.tool === filter);
  return (
    <div className="pf-section">
      <div className="pf-section-head">
        <h2 className="pf-section-title">File History</h2>
        <p className="pf-section-sub">Files processed in the last 30 days · Auto-deleted after 30 days</p>
      </div>
      <div className="pf-filter-chips">
        <button className={`pf-chip${filter === 'all' ? ' active' : ''}`} onClick={() => setFilter('all')}>All ({HISTORY.length})</button>
        {tools.map(t => (
          <button key={t} className={`pf-chip${filter === t ? ' active' : ''}`} onClick={() => setFilter(t)}>{t}</button>
        ))}
      </div>
      <div className="pf-card pf-history-card">
        {filtered.map((h, i) => (
          <div key={i} className="pf-history-row">
            <div className="pf-history-icon"><Ic.Merge /></div>
            <div className="pf-history-info">
              <p className="pf-history-name">{h.file}</p>
              <p className="pf-history-meta">{h.tool} · {h.size}</p>
            </div>
            <div className="pf-history-right">
              <span className="pf-history-date">{h.date}</span>
              <div className="pf-history-actions">
                <button className="pf-icon-btn" title="Download"><Ic.Download /></button>
                <button className="pf-icon-btn pf-icon-btn--del" title="Delete"><Ic.Trash /></button>
              </div>
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="pf-history-empty">No files found for this filter.</div>}
      </div>
    </div>
  );
};

const SectionUsage = () => (
  <div className="pf-section">
    <div className="pf-section-head">
      <h2 className="pf-section-title">Usage Analytics</h2>
      <p className="pf-section-sub">Detailed breakdown of your activity</p>
    </div>
    <div className="pf-card">
      <div className="pf-card-head"><span className="pf-card-title">Files processed last 6 months</span></div>
      <div className="pf-monthly-bars">
        {[{ month: 'Oct', count: 142 }, { month: 'Nov', count: 198 }, { month: 'Dec', count: 167 }, { month: 'Jan', count: 221 }, { month: 'Feb', count: 189 }, { month: 'Mar', count: 284 }].map((m, i) => (
          <div key={i} className="pf-monthly-col">
            <span className="pf-monthly-count">{m.count}</span>
            <div className="pf-monthly-bar-wrap"><div className="pf-monthly-bar" style={{ height: `${(m.count / 284) * 100}%` }} /></div>
            <span className="pf-monthly-label">{m.month}</span>
          </div>
        ))}
      </div>
    </div>
    <div className="pf-row-2">
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">By tool</span></div>
        <div className="pf-tool-list">
          {TOOL_USAGE.map((t, i) => (
            <div className="pf-tool-row" key={i}>
              <span className="pf-tool-name"><span className="pf-tool-ico"><t.icon /></span>{t.name}</span>
              <div className="pf-tool-bar-wrap"><div className="pf-tool-bar" style={{ width: `${t.pct}%` }} /></div>
              <span className="pf-tool-count">{t.count}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="pf-card">
        <div className="pf-card-head"><span className="pf-card-title">By category</span></div>
        {[
          { label: 'Convert',  pct: 36, color: '#F59E0B' },
          { label: 'Organize', pct: 30, color: '#3B82F6' },
          { label: 'Optimize', pct: 22, color: '#10B981' },
          { label: 'Edit',     pct: 8,  color: '#8B5CF6' },
          { label: 'Security', pct: 4,  color: '#EF4444' },
        ].map((c, i) => (
          <div key={i} className="pf-cat-row">
            <span className="pf-cat-dot" style={{ background: c.color }} />
            <span className="pf-cat-label">{c.label}</span>
            <div className="pf-cat-bar-wrap"><div className="pf-cat-bar" style={{ width: `${c.pct}%`, background: c.color }} /></div>
            <span className="pf-cat-count">{c.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// ─── Main component ───────────────────────────────────────────────────────────
export default function Profile() {
  const navigate = useNavigate();
  const [active, setActive] = useState('overview');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const NAV = [
    { id: 'overview', label: 'Overview',     Icon: Ic.Overview },
    { id: 'profile',  label: 'Profile',      Icon: Ic.Profile  },
    { id: 'security', label: 'Security',     Icon: Ic.Security },
    { id: 'billing',  label: 'Billing',      Icon: Ic.Billing  },
    { id: 'history',  label: 'File History', Icon: Ic.History  },
    { id: 'usage',    label: 'Analytics',    Icon: Ic.Usage    },
  ];

  const handleNav = (id) => {
    setActive(id);
    setDrawerOpen(false);
  };

  const render = () => {
    switch (active) {
      case 'overview': return <SectionOverview />;
      case 'profile':  return <SectionProfile />;
      case 'security': return <SectionSecurity />;
      case 'billing':  return <SectionBilling />;
      case 'history':  return <SectionHistory />;
      case 'usage':    return <SectionUsage />;
      default:         return <SectionOverview />;
    }
  };

  return (
    <div className="pf-root">

      {/* ── Topbar ─────────────────────────────────────────── */}
      <header className="pf-topbar">
        <div className="pf-topbar-left">
          {/* Hamburger — mobile only */}
          <button className="pf-hamburger" onClick={() => setDrawerOpen(true)} aria-label="Open menu">
            <Ic.Menu />
          </button>
          <span className="pf-topbar-title">Account</span>
          <span className="pf-topbar-slash">/</span>
          <span className="pf-topbar-sub">{NAV.find(n => n.id === active)?.label}</span>
        </div>
        <div className="pf-topbar-right">
          <span className="pf-plan-pill" style={{ background: '#EFF6FF', color: '#3B82F6' }}>
            <Ic.Zap /> Pro
          </span>
          <div className="pf-topbar-avatar">{USER.avatar}</div>
        </div>
      </header>

      {/* ── Mobile drawer overlay ──────────────────────────── */}
      <div
        className={`pf-drawer-overlay${drawerOpen ? ' open' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* ── Mobile slide-in drawer ─────────────────────────── */}
      <div className={`pf-drawer${drawerOpen ? ' open' : ''}`}>
        {/* Drawer header */}
        <div className="pf-drawer-top">
          <span className="pf-drawer-brand">Account</span>
          <button className="pf-drawer-close" onClick={() => setDrawerOpen(false)} aria-label="Close menu">
            <Ic.X />
          </button>
        </div>

        {/* User info */}
        <div className="pf-drawer-user">
          <div className="pf-avatar">{USER.avatar}</div>
          <div>
            <p className="pf-drawer-name">{USER.name}</p>
            <p className="pf-drawer-email">{USER.email}</p>
          </div>
        </div>

        {/* Nav items */}
        <nav className="pf-drawer-nav">
          {NAV.map(item => (
            <button
              key={item.id}
              className={`pf-nav-item${active === item.id ? ' active' : ''}`}
              onClick={() => handleNav(item.id)}
            >
              <item.Icon />
              {item.label}
            </button>
          ))}
        </nav>

        <div className="pf-drawer-divider" />

        {/* Sign out */}
        <div className="pf-drawer-bottom">
          <button
            className="pf-nav-item pf-nav-item--logout"
            onClick={() => { setDrawerOpen(false); navigate('/'); }}
          >
            <Ic.Logout /> Sign out
          </button>
        </div>
      </div>

      <div className="pf-body">

        {/* ── Sidebar (desktop only) ────────────────────────── */}
        <aside className="pf-sidebar">
          <div className="pf-sidebar-user">
            <div className="pf-avatar">{USER.avatar}</div>
            <div className="pf-sidebar-user-info">
              <p className="pf-sidebar-name">{USER.name}</p>
              <p className="pf-sidebar-email">{USER.email}</p>
            </div>
          </div>
          <div className="pf-sidebar-divider" />
          <nav className="pf-nav">
            {NAV.map(item => (
              <button
                key={item.id}
                className={`pf-nav-item${active === item.id ? ' active' : ''}`}
                onClick={() => setActive(item.id)}
              >
                <item.Icon />
                {item.label}
              </button>
            ))}
          </nav>
          <div className="pf-sidebar-divider" />
          <div className="pf-sidebar-bottom">
            <button className="pf-nav-item pf-nav-item--logout" onClick={() => navigate('/')}>
              <Ic.Logout /> Sign out
            </button>
          </div>
        </aside>

        {/* ── Main content ──────────────────────────────────── */}
        <main className="pf-main">
          {render()}
        </main>
      </div>

    </div>
  );
}